import { render } from "./TableShow.vue?vue&type=template&id=3c625226&scoped=true"
import script from "./TableShow.vue?vue&type=script&lang=js"
export * from "./TableShow.vue?vue&type=script&lang=js"

import "./TableShow.vue?vue&type=style&index=0&id=3c625226&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c625226"],['__file',"src/views/AfterSales/editTask/components/TableShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c625226"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c625226', __exports__)) {
    api.reload('3c625226', __exports__)
  }
  
  module.hot.accept("./TableShow.vue?vue&type=template&id=3c625226&scoped=true", () => {
    api.rerender('3c625226', render)
  })

}


export default __exports__